import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

type Props = {
    close: () => void;
}

const ModalCloseButton: React.FC<Props> = ({ close }) => {
    return (
        <div style={{
            position: "absolute",
            textAlign: "center",
            right: "10px"
        }}>
            <IconButton aria-label="close" onClick={close}>
                <CloseIcon />
            </IconButton>
        </div>
    );
}

export default ModalCloseButton;